module.exports = __webpack_public_path__ + "static/media/Lato-v15-latin-600.57d69e1d.ttf";